// extracted by mini-css-extract-plugin
export var modal = "_ur-0";
export var table = "_ur-1";